import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useState } from '@hookstate/core';
import { ClickAwayListener } from '@material-ui/core';
import { IEquipmentStatus } from '@models/EquipmentStatus.model';
import { CSSTransition } from 'react-transition-group';

import {
  Circle,
  IconChevRightAwesome,
} from '@pages/Asset/components/Legacy/AddProductContent/ChangeEquipmentStatus.styles';
import { beam } from '@styles/colors/themes';
import { ChangeEquipmentStatus } from './ChangeEquipmentStatus/ChangeEquipmentStatus';

import {
  Block,
  ButtonText,
  Container,
  ContainerSidebar,
} from './EquipmentStatusSelector.styles';

interface AddProductProps {
  equipmentStatus?:
    | Pick<IEquipmentStatus, 'name' | 'id' | 'category'>
    | undefined;
  onClickStatus: (
    input: Pick<IEquipmentStatus, 'name' | 'id' | 'category'>,
  ) => void;
  disabled?: boolean;
}
const getColor = ({
  equipmentStatus,
}: Pick<AddProductProps, 'equipmentStatus'>): string => {
  if (!equipmentStatus) return 'transparent';
  if (equipmentStatus.category === 'Online') return beam.status.online;
  if (equipmentStatus.category === 'Offline') return beam.status.offline;
  if (equipmentStatus.category === 'Decommissioned')
    return beam.status.decommissioned;
  return 'transparent';
};
const EquipmentStatusSelector = ({
  equipmentStatus,
  onClickStatus,
  disabled,
}: AddProductProps) => {
  const open = useState(false);

  const handleClickAway = () => {
    // open.set(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ContainerSidebar
          data-disabled={disabled}
          onClick={() => {
            if (disabled) return;
            open.set(!open.get());
          }}
        >
          <ButtonText>
            <Circle
              color={getColor({
                equipmentStatus,
              })}
            />
            {equipmentStatus ? equipmentStatus.name : 'Status'}
            <IconChevRightAwesome icon={faChevronDown} />
          </ButtonText>
        </ContainerSidebar>

        <CSSTransition
          in={open.get()}
          timeout={1}
          classNames="my-node"
          unmountOnExit
          onEnter={() => open.set(true)}
          onExited={() => open.set(false)}
        >
          <Block>
            <ChangeEquipmentStatus
              openAddField={open}
              actualStatus={equipmentStatus}
              onClickStatus={onClickStatus}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { EquipmentStatusSelector };
